function initBlogSidebar() {
  // var search_url = window.location.href;
  //   if(search_url.includes('search?type=article')){
  //     console.log('fgg');
  //     setTimeout(function() {
  //       $('#SearchResultSubmit').trigger('click');
  //     }, 500);
  //   }
    
    if($('body').hasClass('template-collection')){
      var url = window.location.href;
      console.log(url)
    
      if(url.includes('sort_by')){
        $('html, body').animate({
          scrollTop: $(".collection-header").offset().top - 100
        }, 300);
      }
    }
  
    //for article filter code
    $(".blog-sidebar .nav-block .nav-title").on('click', function(){
      $(this).toggleClass('is-open');
      $(this).siblings(".nav-list").slideToggle();
    });
    var width = $(window).width();
    console.log(width);
  
    if(width < 769){
      $(".blog-sidebar .nav-block .nav-list").removeClass('active');
    
        var first = $('.blog-sidebar .nav-block').eq(0).find('span.active').data('val');
        var second = $('.blog-sidebar .nav-block').eq(1).find('span.active').data('val');
        var third = $('.blog-sidebar .nav-block').eq(2).find('span.active').data('val');
    
      if(first){
        $('.blog-sidebar .selected_tag ul').append('<li>'+first+'<span class="close_tag" data-val="'+first+'">X</span></li>');
      }
      if(second){
        $('.blog-sidebar .selected_tag ul').append('<li>'+second+'<span class="close_tag" data-val="'+second+'">X</span></li>');
      }
      if(third){
        $('.blog-sidebar .selected_tag ul').append('<li>'+third+'<span class="close_tag" data-val="'+third+'">X</span></li>');
      }
    }
  
    $('.blog-sidebar .selected_tag ul li span.close_tag').click(function(){
      var val = $(this).data('val');
      console.log(val);
      $('.blog-sidebar .nav-block .nav-list li[data-val="'+val+'"]').trigger('click');
    });
  
    var b_filter_l = $(".blog-sidebar .nav-block .nav-list .filter-links.active").length;
    console.log(b_filter_l);
    if(b_filter_l > 0){
      $('.blog-sidebar .all-links').css('display','block');
    }
  
    $('.collection-hero__title .learn_more_div .learn_more_text').click(function(){
      $(this).css('display','none');
      $('.collection-hero__title .collection-description.medium-up--hide').css('display','block');
    });
    
  if(width > 769){
  $('.blog-sidebar .nav-block').each(function(){
    if($(this).find('span').hasClass('active')){
      $(this).find('.nav-title').addClass('is-open');
      $(this).find(".nav-list").addClass('active');
    }
  });
  }
    $(".blog-sidebar .nav-block .nav-list li").click(function(){
      var val = $(this).find('span').data('val');
      var url = window.location.origin + window.location.pathname;
      console.log(val);
      console.log(url);
      if($(this).find('span').hasClass('active')){
        var has_active = 1;
      }
    
      if(has_active != 1){
      if($(this).siblings().find('span').hasClass('active')){
        $(this).siblings().find('span').removeClass('active');
        
        $(this).find('span').addClass('active');
      
        var first = $('.blog-sidebar .nav-block').eq(0).find('span.active').data('val');
        var second = $('.blog-sidebar .nav-block').eq(1).find('span.active').data('val');
        var third = $('.blog-sidebar .nav-block').eq(2).find('span.active').data('val');
        console.log(first);
        console.log(second);
        console.log(third);
        var url = url.split('/tagged/');
              if(first){
          if(second && third){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
            window.location.href = new_url;
          }else if(second){
            var new_url = url[0] + "/tagged/" + first + '+' + second;
            window.location.href = new_url;
          }else if(third){
            var new_url = url[0] + "/tagged/" + first + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + first;
            window.location.href = new_url;
          }
        }else if(second){
          if(first && third){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
           window.location.href = new_url;
          }else if(first){
            var new_url = url[0] + "/tagged/" + first + '+' + second;
            window.location.href = new_url;
          }else if(third){
            var new_url = url[0] + "/tagged/" + second + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + second;
            window.location.href = new_url;
          }
        }else if(third){
          if(first && second){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
            window.location.href = new_url;
          }else if(first){
            var new_url = url[0] + "/tagged/" + first + '+' + third;
            window.location.href = new_url;
          }else if(second){
            var new_url = url[0] + "/tagged/" + second + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + third;
            window.location.href = new_url;
          }
        }else{
                var new_url = url[0];
                window.location.href = new_url;
        }
        
      }else{
        $(this).find('span').addClass('active');
      
        var first = $('.blog-sidebar .nav-block').eq(0).find('span.active').data('val');
        var second = $('.blog-sidebar .nav-block').eq(1).find('span.active').data('val');
        var third = $('.blog-sidebar .nav-block').eq(2).find('span.active').data('val');
        console.log(first);
        console.log(second);
        console.log(third);
        var url = url.split('/tagged/');
        if(first){
          if(second && third){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
            window.location.href = new_url;
          }else if(second){
            var new_url = url[0] + "/tagged/" + first + '+' + second;
            window.location.href = new_url;
          }else if(third){
            var new_url = url[0] + "/tagged/" + first + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + first;
            window.location.href = new_url;
          }
        }else if(second){
          if(first && third){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
           window.location.href = new_url;
          }else if(first){
            var new_url = url[0] + "/tagged/" + first + '+' + second;
            window.location.href = new_url;
          }else if(third){
            var new_url = url[0] + "/tagged/" + second + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + second;
            window.location.href = new_url;
          }
        }else if(third){
          if(first && second){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
            window.location.href = new_url;
          }else if(first){
            var new_url = url[0] + "/tagged/" + first + '+' + third;
            window.location.href = new_url;
          }else if(second){
            var new_url = url[0] + "/tagged/" + second + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + third;
            window.location.href = new_url;
          }
        }else{
                var new_url = url[0];
                window.location.href = new_url;
        }
      }
        }else{
        
        $(this).find('span').removeClass('active');
        
        var first = $('.blog-sidebar .nav-block').eq(0).find('span.active').data('val');
        var second = $('.blog-sidebar .nav-block').eq(1).find('span.active').data('val');
        var third = $('.blog-sidebar .nav-block').eq(2).find('span.active').data('val');
        console.log(first);
        console.log(second);
        console.log(third);
        var url = url.split('/tagged/');
        if(first){
          if(second && third){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
            window.location.href = new_url;
          }else if(second){
            var new_url = url[0] + "/tagged/" + first + '+' + second;
            window.location.href = new_url;
          }else if(third){
            var new_url = url[0] + "/tagged/" + first + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + first;
            window.location.href = new_url;
          }
        }else if(second){
          if(first && third){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
           window.location.href = new_url;
          }else if(first){
            var new_url = url[0] + "/tagged/" + first + '+' + second;
            window.location.href = new_url;
          }else if(third){
            var new_url = url[0] + "/tagged/" + second + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + second;
            window.location.href = new_url;
          }
        }else if(third){
          if(first && second){
            var new_url = url[0] + "/tagged/" + first + '+' + second + '+' + third;
            window.location.href = new_url;
          }else if(first){
            var new_url = url[0] + "/tagged/" + first + '+' + third;
            window.location.href = new_url;
          }else if(second){
            var new_url = url[0] + "/tagged/" + second + '+' + third;
            window.location.href = new_url;
          }else{
             var new_url = url[0] + "/tagged/" + third;
            window.location.href = new_url;
          }
        }else{
                var new_url = url[0];
                window.location.href = new_url;
        }
        }
      
      // if(!url.includes(val)){
      // if(url.includes('tagged')){      
      //   var new_url = url + "+" + val;
      //   console.log(new_url);
      //   window.location.href = new_url;
      // }else{
      //   var new_url = url + "/tagged/" + val;
      //   console.log(new_url);
      //   window.location.href = new_url;
      // }
      //   }else{
      
      //   if(url.includes('+'+val)){
      //     console.log('+val');
      //     var new_url = url.replace('+'+val,'');
      //     window.location.href = new_url;
      //   }else if(url.includes('/'+val+'+')){
      //     console.log('/val+');
      //     var new_url = url.replace(val+'+','');
      //     window.location.href = new_url;
      //   }else if(url.includes('/'+val)){
      //     console.log('/val');
      //      var new_url = url.replace('/tagged/'+val,'');
      //     window.location.href = new_url;
      //   }
      //   }
    });
    // $(".blog-sidebar .nav-block ul.nav-list li.has-child").click(function(){
    //   $(this).toggleClass('is-open');
    //   $(this).find('ul.nav-sub-list').slideToggle();
    // });
  
    //end article filter code
    
      $('.js-load-more').on('click', function(){
        var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
        $this.attr('disabled', true);
        $this.find('[loader]').removeClass('hide');
        $this.find('[load-more-text]').addClass('hide');
        currentPage = currentPage+1;
        var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
        $('[data-current-page]').val(currentPage);
        $.ajax({
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(responseHTML){
            $('.grid.grid--uniform').append($(responseHTML).find('.grid.grid--uniform').html());
          },
          complete: function() {
            if(currentPage <= totalPages) {
              $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
              $this.hide();
            } 
          }
        })
      });
    
  //   $('.upsell_reproducts').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1 
  //   });

}

$(document).ready(function(){
  initBlogSidebar();
});